"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthenticatedDomain = void 0;
const MessageOutbox_1 = require("./message/MessageOutbox");
const utils_1 = require("./utils");
const EditOutbox_1 = require("./message/EditOutbox");
class UnauthenticatedDomain {
    constructor(adapterFactory, config, internetStatusManager, organizationIdStorage, deviceTokenProvider) {
        this.domainType = "unauthenticated";
        this.user = null;
        this.isPasswordChangeRequired = false;
        this.isLoginError = false;
        this.changeListeners = [];
        this.internetStatusManager = internetStatusManager;
        this.adapterFactory = adapterFactory.withAuthStatusManager(this);
        this.authAdapter = adapterFactory.createAuthAdapter();
        this.config = config;
        this.organizationIdStorage = organizationIdStorage;
        this.deviceTokenProvider = deviceTokenProvider;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.organizationIdStorage.clearOrganizationId();
            yield MessageOutbox_1.MessageOutbox.getInstance().clear();
            yield EditOutbox_1.EditOutbox.getInstance().clear();
            yield this.authAdapter.clearAuthSession();
            return true;
        });
    }
    createAuthenticatedDomain() {
        return __awaiter(this, void 0, void 0, function* () {
            const { AuthenticatedDomain } = yield Promise.resolve().then(() => __importStar(require("./AuthenticatedDomain")));
            return new AuthenticatedDomain(this.adapterFactory, this.config, this.internetStatusManager, this.organizationIdStorage, this.deviceTokenProvider);
        });
    }
    login() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isLoginError = false;
            this.isPasswordChangeRequired = false;
            // If the adapter is already authenticated (returning from a Cognito Hosted
            // UI callback, or another tab signed in and the cookie store updated),
            // skip the redirect and transition straight to AuthenticatedDomain.
            const isAuthenticated = yield this.authAdapter.isAuthenticated();
            if (isAuthenticated) {
                const authenticatedDomain = yield this.createAuthenticatedDomain();
                try {
                    if (yield authenticatedDomain.init()) {
                        this.notifyChange(authenticatedDomain);
                        return;
                    }
                }
                catch (error) {
                    if (error.code !== "FORCE_LOGOUT") {
                        throw error;
                    }
                    this.init();
                }
                return;
            }
            // Not authenticated — initiate the external sign-in flow. The adapter
            // performs a full-page redirect to Cognito Hosted UI; this call typically
            // does not resolve on success (the browser navigates away). On return,
            // login() is called again (by the SSO bridge in the host app's bootstrap
            // when SessionManager flips isLoggedIn to true) and takes the
            // `isAuthenticated` branch above to complete the transition.
            yield this.authAdapter.signInWithRedirect();
        });
    }
    forgotPassword(email) {
        return __awaiter(this, void 0, void 0, function* () {
            if (email) {
                try {
                    yield this.authAdapter.forgotPassword(email);
                }
                catch (e) {
                    throw new utils_1.HhnException(e);
                }
            }
        });
    }
    resetPassword(email, otp, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authAdapter.resetPassword(email, otp, newPassword);
        });
    }
    setPassword(newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authAdapter.setPassword(newPassword);
        });
    }
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
    checkUserAuthentication() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const isUserAuthenticated = yield ((_a = this.authAdapter) === null || _a === void 0 ? void 0 : _a.isAuthenticated());
            if (isUserAuthenticated) {
                throw new Error("Panic: user shouldn't be in authenticated state within unauthenticated domain");
            }
            return false;
        });
    }
    isUserLoggedIn() {
        return false;
    }
    registerChangeListener(cb) {
        this.changeListeners.push(cb);
        return () => {
            this.changeListeners = this.changeListeners.filter(listener => listener !== cb);
        };
    }
    subscribeToCrossTabAuthChanges(callback) {
        return this.authAdapter.subscribeToCrossTabAuthChanges(callback);
    }
    destroy() {
        throw new Error("Nothing to destroy on Unauthenticated domain");
    }
    logoutUser() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("logoutUser ==> Not allowed in unauthenticated state");
        });
    }
    unexpectedlyLostAccess() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("unexpectedlyLostAccess ==> Not allowed in unauthenticated state");
        });
    }
    updateDeviceToken() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("updateDeviceToken ==> Not allowed in unauthenticated state");
        });
    }
    clearDeviceToken() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("clearDeviceToken ==> Not allowed in unauthenticated state");
        });
    }
    notifyChange(replacementDomain) {
        const domainToNotify = replacementDomain || this;
        this.changeListeners.forEach(cb => cb(domainToNotify));
    }
}
exports.UnauthenticatedDomain = UnauthenticatedDomain;
